import ITrainer, { TrainerTypes } from "types/Trainer";
import Utils from "./index";

const getSpecialTrainingsChart = (trainers: ITrainer[], type: TrainerTypes) => {
  const trainersOfType = trainers.reduce((accum, curr) => {
    if (curr.type.includes(type)) {
      accum += 1;
    }

    return accum;
  }, 0);

  const labels = [...Array(trainersOfType)].map((_, i) => `${i + 1} Trainer(s)`);

  const level1 = [...Array(trainersOfType)].map((_, i) => {
    return Utils.getTrainingReward(trainers, i + 1, 1, type);
  });

  const level2 = [...Array(trainersOfType)].map((_, i) => {
    return Utils.getTrainingReward(trainers, i + 1, 2, type);
  });

  const level3 = [...Array(trainersOfType)].map((_, i) => {
    return Utils.getTrainingReward(trainers, i + 1, 3, type);
  });

  const datasets = [
    {
      label: "Lvl. 1 Facility",
      data: level1,
      backgroundColor: "#f39cff",
    },
    {
      label: "Lvl. 2 Facility",
      data: level2,
      backgroundColor: "#ffa49c",
    },
    {
      label: "Lvl. 3 Facility",
      data: level3,
      backgroundColor: "#ffe46b",
    },
  ];

  return {
    labels,
    datasets,
  };
};

const ChartUtils = {
  getSpecialTrainingsChart,
};

export default ChartUtils;
